import { AddEditPackingMaterial, AddEditRawMaterial, DeletePackingMaterialById, DeleteRawMaterialById, GetAllPackingMaterials, GetAllRawMaterials, GetPackingMaterialById, GetRawMaterialById } from "../ApiEndPoints.js";
import { axiosGetMultiParams, axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class MasterServices {


    // Raw Material
    async getAllRawMaterials(request) {
        return axiosGetMultiParams(GetAllRawMaterials, request);
    }
    async getRawMaterialById(request) {
        return axiosGetWithencryption(GetRawMaterialById, request);
    }
    async addEditRawMaterial(request) {
        return axiosPostWithencryption(AddEditRawMaterial, request)
    }
    async deleteRawMaterialById(request) {
        return axiosGetWithencryption(DeleteRawMaterialById, request)
    }

    // Packing Material
    async getAllPackingMaterials(request) {
        return axiosGetMultiParams(GetAllPackingMaterials, request);
    }
    async getPackingMaterialById(request) {
        return axiosGetWithencryption(GetPackingMaterialById, request);
    }
    async addEditPackingMaterial(request) {
        return axiosPostWithencryption(AddEditPackingMaterial, request)
    }
    async deletePackingMaterialById(request) {
        return axiosGetWithencryption(DeletePackingMaterialById, request)
    }
}

